import { Button, Grid, Typography } from "@mui/material"
import { useTranslation } from "react-i18next"
import { useState } from "react"
import failureBanner from "../../../../assets/payment_failure_banner.svg"
import { OrderRequest, postCreateOrder } from "../../../../services/ntuc/memberService/payment"
import { getMembershipPayment } from "../../../../services/ntuc/paymentService/payment"
import { MembershipPaymentAcknowledgementPageProps } from "../../../../views/arrears-payment-flow/AcknowledgementPage/AcknowledgementPage"
import { ArrearsRoute } from "../../../../views/arrears-payment-flow/ArrearsPaymentFlow/ArrearsPaymentFlow"
import PaymentAcknowledgementBanner from "../../PaymentAcknowledgementBanner"
import { DeviceType } from "../../../../services/ntuc/memberService/oaMembership"

const MembershipPaymentFailure = (props: MembershipPaymentAcknowledgementPageProps) => {
    const { orderId, order, onNavigateTo } = props
    const { t } = useTranslation(`arrears-payment`)
    const [loading, setLoading] = useState(false)

    const handleHomeClick = () => {
        if (window.myNtucConfig.paymentBackToHomeHomeUrl != undefined) {
            window.location.replace(window.myNtucConfig.paymentBackToHomeHomeUrl)
        } else {
            onNavigateTo(ArrearsRoute.Main)
        }
    }

    const redirectToPaymentGateway = (clientOrderId: string) => {
        window.location.replace(getMembershipPayment(clientOrderId))
    }

    const handleTryAgainClick = () => {
        const orderRequest: OrderRequest = {
            feeType: order!.feeType,
            endDate: order!.endDate,
            startDate: order!.startDate,
            serviceType: order!.serviceType,
            noOfMonths: order!.noOfMonths,
            amount: order!.amount,
            isOneTimePayment: order!.isOneTimePayment,
            isRecurringPayment: order!.isRecurringPayment,
            membershipId: order!.membershipId,
            deviceType: DeviceType.WEB,
            renewalCampaignCode: order?.renewalCampaignCode ? order.renewalCampaignCode : undefined,
        }

        if (orderRequest) {
            setLoading(true)
            postCreateOrder(orderRequest)
                .then(response => response.data.content.clientOrderId)
                .then(redirectToPaymentGateway)
                .catch(error => error.response.data.content)
                .then(console.error)
                .then(() => setLoading(false))
        }

    }

    return (
        <Grid rowSpacing={3} container justifyContent="center" padding={2}>
            <PaymentAcknowledgementBanner bannerUrl={failureBanner} alt="Payment failure banner" />
            <Grid item justifyContent="center" xs={12}>
                <Typography textAlign="center" variant="h2">{t(`paymentUnsuccessful`)}</Typography>
            </Grid>
            <Grid item justifyContent="center" xs={12}>
                <Typography textAlign="center">{t(`unableToCompletePayment`)}</Typography>
            </Grid>
            <Grid item justifyContent="center" xs={12}>
                <Typography color="text.secondary" textAlign="center">{t(`reference`)}</Typography>
                <Typography textAlign="center" data-testid="reference">{orderId}</Typography>
            </Grid>
            <Grid container item xs={12} sm={12} md={6} lg={6} mt={3} justifyContent='center'>
                <Button onClick={handleTryAgainClick} variant="contained" color="primary" size="large" sx={{ marginX: 5, marginY: 1 }} disabled={loading}>
                    {t(`try_again`)}
                </Button>
                <Button onClick={handleHomeClick} variant="contained" color="secondary" size="large" sx={{ marginX: 5, marginY: 1 }}>
                    {t(`home`)}
                </Button>
            </Grid>
        </Grid>
    )
}

export default MembershipPaymentFailure